import React from 'react'
import { useFt } from 'hooks'
import { constants } from 'helpers'

import { loadable } from 'containers/Routes/util'

import BaseBrandsBanner from './components/BaseBrandsBanner/BaseBrandsBanner'


const StrapiBrandsBanner = loadable(() => import('./components/StrapiBrandsBanner/StrapiBrandsBanner'), { ssr: false })


type BrandsBannerProps = {
  type: 'perfumes' | 'colognes'
  onClick?: () => void
}

const BrandsBanner: React.FunctionComponent<BrandsBannerProps> = (props) => {
  const isStrapiBannersEnabled = useFt(constants.features.strapiBanners) && __DEV__
  const BannerComponent = isStrapiBannersEnabled ? StrapiBrandsBanner : BaseBrandsBanner

  return (
    <BannerComponent {...props} />
  )
}


export default BrandsBanner
